import React from 'react';

/**
 * Standard content card. One radius (rounded-lg), one resting elevation
 * (shadow-sm), consistent border — pass hover to lift on mouseover.
 *
 * <Card>...</Card>
 * <Card hover padding="lg">...</Card>
 * <Card header={<h2 className="text-lg font-semibold">Recent Orders</h2>}>...</Card>
 */
const PADDINGS = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

function Card({ header, footer, hover = false, padding = 'md', className = '', children, ...props }) {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200
        ${hover ? 'transition-shadow duration-200 hover:shadow-md' : ''}
        ${className}`}
      {...props}
    >
      {header && (
        <div className="px-6 py-4 border-b border-gray-200">{header}</div>
      )}
      <div className={PADDINGS[padding] ?? PADDINGS.md}>{children}</div>
      {footer && (
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">{footer}</div>
      )}
    </div>
  );
}

export default Card;
